import { Id } from '@/infra/id'

/**
 * Links to routes.
 */
export const links = {
  welcome: () => `/`,
  logout: (url?: string) => `/logout${url ? '?redirect_to=' + url : ''}`,
  opportunities: () => `/opportunities`,
  jobs: () => `/jobs`,
  job: (jobId: Id) => `/jobs/${Id.assert(jobId)}`,
  notifications: (jobId?: Id) => `/notifications${jobId ? `/${jobId}` : ''}`,
  checkout: (jobId: Id) => `/jobs/${Id.assert(jobId)}/checkout`,
  mobileJob: (jobId: Id) => `/mobile/jobs/${Id.assert(jobId)}`,
  documents: () => `/documents`,
  proPayouts: () => '/payouts',
  teams: () => `/teams`,
  team: (teamSlug?: string) => `/teams${teamSlug ? `/${teamSlug}` : ''}`,
  adminChangeRequests: () => `/admin/change-requests`,
  adminServiceManager: () => `/admin/service-manager`,
  adminBundleManager: () => `/admin/bundle-manager`,
  adminStaffingManager: () => `/admin/staffing-manager`,
  adminPayouts: () => `/admin/payouts`,
  adminBookkeepingManager: () => `/admin/bookkeeping-manager`,
  adminPayoutsReview: () => `/admin/payouts/review`,
  adminAccountMergeRequests: () => `/admin/merge-requests`,
  adminPayoutsTransactions: () => `/admin/payouts/transactions`,
  profileGeneral: () => `/profile/general`,
  profileBilling: () => `/profile/billing`,
  profileBillingPaymentMethods: () => `/profile/billing/payment-methods`,
  profileBillingPayoutMethod: () => `/profile/billing/payout-method`,
  profileNotifications: () => `/profile/notifications`,
  emailConfirmed: () => '/email-confirmed',
  about: () => '/about',
  editDraftJob: (id: Id) => `/new/${Id.assert(id)}`,
  firmDashboard: () => '/dashboard',
  scopingJobs: () => '/scoping-jobs',
  scopingJob: (scopingId: Id) => `/scoping-jobs/${Id.assert(scopingId)}`,
  legends: () => `/legends`,
  legend: (legendId: Id, tab?: string) =>
    `/legends/${Id.assert(legendId)}${tab ? `/${tab}` : ''}`,
  userManagement: () => `/users`,
  userDetails: (userPublicId: Id) => `/users/${Id.assert(userPublicId)}`,
  clientUserManagement: () => `/clients`,
  clientUserDetails: (userPublicId: Id) =>
    `/clients/${Id.assert(userPublicId)}`,
  callCenter: () => `/call-center`,
  callCenterJob: (jobId: Id) => `/call-center/${Id.assert(jobId)}`,
  callCenterJobCheckout: (jobId: Id) =>
    `/call-center/${Id.assert(jobId)}/checkout`,
}

/**
 * External links.
 */
export const externalLinks = {
  proSupportTicket: () => 'https://www.taxfyle.com/pro-support-ticket',
  txfIntelligenceWebinar: () =>
    'https://www.taxfyle.com/pro/txf-intelligence-webinar',
  ptinRenewal: () =>
    'https://www.taxfyle.com/ptin-renewal?_hsenc=p2ANqtz-9iQqtGsdr7HzhgQqiJ0a0dyg1A9SypjOzkKSELh50CLEJKBCrrKgJfVF5xnP6dYnO91wyB',
}
